import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-curriculum-swiper',
  templateUrl: './curriculum-swiper.component.html',
  styleUrls: ['./curriculum-swiper.component.scss']
})
export class CurriculumSwiperComponent implements OnInit {

  showContact: boolean = false;
  firstLoad: boolean = true;
  constructor() { }

  ngOnInit(): void {
  }

  hideOrShowContact(): void{
    this.firstLoad = false;
    this.showContact = !this.showContact;
  }
}
